<app-expandable-section
  [title]="'DEAD_LETTERS.DETAIL.SECTIONS.OVERVIEW' | translate"
  [(expanded)]="expanded"
  (expandedChange)="expandedChange.emit($event)">
  @if (detail) {
    <div class="overview-grid">
      <div class="metadata-item">
        <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.EVENT_TYPE' | translate }}</span>
        <span class="value">{{ detail.eventType }}</span>
      </div>
      <div class="metadata-item">
        <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.EVENT_TIME' | translate }}</span>
        <span class="value value-copyable" [matTooltip]="detail.eventTime">{{ detail.eventTime | date:'medium' }}</span>
      </div>
      <div class="metadata-item">
        <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.TOPIC_NAME' | translate }}</span>
        <span class="value value-copyable">{{ detail.topicName }}</span>
      </div>
      <div class="metadata-item">
        <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.SUBSCRIPTION_NAME' | translate }}</span>
        <span class="value value-copyable">{{ detail.subscriptionName }}</span>
      </div>
      <div class="metadata-item metadata-item-wide">
        <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.SUBJECT' | translate }}</span>
        <span class="value value-copyable">{{ detail.subject }}</span>
      </div>
      <div class="metadata-item metadata-item-wide">
        <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.BLOB_PATH' | translate }}</span>
        <span class="value value-copyable">{{ detail.blobPath }}</span>
      </div>
    </div>
  }
</app-expandable-section>